import { Route, Switch, useLocation } from 'wouter'
import { useAuth } from './contexts/AuthContext'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import StagesManager from './pages/admin/StagesManager'
import DocumentsManager from './pages/admin/DocumentsManager'
import LogsList from './pages/admin/LogsList'
import ReportsManager from './pages/admin/ReportsManager'
import { useEffect, useState } from 'react'

function PrivateRoute({ component: Component, ...rest }: any) {
  const { isAuthenticated, isLoading, checkAuth } = useAuth()
  const [, navigate] = useLocation()
  const [isVerifying, setIsVerifying] = useState(true)

  useEffect(() => {
    const verify = async () => {
      console.log('[PRIVATE_ROUTE] Verificando autenticação...')
      const isValid = await checkAuth()
      setIsVerifying(false)
      
      if (!isValid) {
        console.log('[PRIVATE_ROUTE] ❌ Não autenticado, redirecionando para login')
        navigate('/admin/login')
      } else {
        console.log('[PRIVATE_ROUTE] ✅ Autenticado')
      }
    }
    verify()
  }, [checkAuth, navigate])

  if (isLoading || isVerifying) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1D71C3] mx-auto mb-4"></div>
          <p className="text-gray-500">Verificando autenticação...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <Component {...rest} />
}

function AppRoutes() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/dashboard" component={() => <PrivateRoute component={AdminDashboard} />} />
      <Route path="/admin/stages" component={() => <PrivateRoute component={StagesManager} />} />
      <Route path="/admin/documents" component={() => <PrivateRoute component={DocumentsManager} />} />
      <Route path="/admin/logs" component={() => <PrivateRoute component={LogsList} />} />
      <Route path="/admin/reports" component={() => <PrivateRoute component={ReportsManager} />} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default AppRoutes